<template>
  <div>
    <div
      v-if="stringValue"
      class="d-flex d-lg-inline-flex justify-content-center mx-auto text-center"
    >
      <NumberBox
        v-for="(item, index) in stringValue"
        :key="index"
        :item="item"
        :red="red"
      ></NumberBox>
    </div>
    <div v-else class="d-flex d-lg-inline-flex justify-content-center mx-auto text-center">
      <NumberBox
        v-for="(item, index) in loaderValue"
        :key="index"
        :item="item"
        :red="red"
      ></NumberBox>
    </div>
    <p
      v-if="text"
      class="text-filter-label text-blue-500 font-weight-bold d-block d-lg-inline-flex mx-sm-1 text-center text-lg-left mb-0 mt-1 mt-md-0 number-board-text"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
import NumberBox from '@/components/widgets/NumberBox.vue'

export default {
  name: 'NumbersBoard',
  components: { NumberBox },
  props: {
    value: {
      required: true
    },
    red: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: false
    }
  },
  computed: {
    stringValue() {
      return this.value && this.value.toString().padStart(4, '0')
    },
    loaderValue() {
      return '----'
    }
  }
}
</script>
